// extracted by css-extract-rspack-plugin
export default {"row":"integrated-messaging-sender__row___DD3Yg"};